import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { UserAvatar } from '../../models/user';

@Component({
  selector: 'lh-user-control',
  templateUrl: './user-control.component.html',
  styleUrls: ['./user-control.component.scss'],
})
export class UserControlComponent {
  @Input('show')
  showAvatarFlyout = false;

  @Output('showChange')
  showAvatarFlyoutChange = new EventEmitter<boolean>();

  @Input()
  user: UserAvatar | null = null;

  constructor(private ref: ElementRef) {}

  // Handle click outside of flyout.
  @HostListener('document:click', ['$event'])
  clickOnOther(event: any) {
    if (!this.ref.nativeElement.contains(event.target)) {
      this.showAvatarFlyout = false;
    }
  }

  toggleAvatarFlyout(): void {
    this.showAvatarFlyout = !this.showAvatarFlyout;
    this.showAvatarFlyoutChange.emit(this.showAvatarFlyout);
  }
}
